import React from 'react';
import UploadErrorComponent from '@cp/src/components/UploadComponent/UploadErrorComponent';
import UploadSuccessComponent from '@cp/src/components/UploadComponent/UploadSuccessComponent';
import UploadComponent from './UploadComponent';
import { CustomFileUploadComponent } from '@cp/src/pages/Enach/Components/CustomFileUploadComponent';
import { UploadedFileStatesV2Props } from './interface';

const UploadedFileStates: React.FC<UploadedFileStatesV2Props> = ({
  error,
  file,
  setFile,
  setError,
  showLoadingComponent,
  setShowLoadingComponent,
  supportedFile,
  handleDownloadClick,
  styles,
  isSampleFileAvailable,
  statesContainerClassName = 'mr-3 mb-3',
  errorContainerClassName = 'flex items-center mr-3 mb-3 !mb-1',
  messageClassName = '!ml-4 !mt-0'
}) => {
  const hasErrorState = error?.message;
  const hasLoadingState = !hasErrorState && file && showLoadingComponent;
  const hasSuccessState = !hasErrorState && file && !showLoadingComponent;

  if (hasErrorState) {
    return (
      <UploadErrorComponent
        containerClassName={errorContainerClassName}
        message={error?.message}
        fileName={error?.fileName || ''}
        showRetryIcon={false}
        showValidationText
        onCancel={() => {
          setError({ message: '', fileName: '' });
          setFile(null);
        }}
        messageClassName={messageClassName}
      />
    );
  }

  if (hasLoadingState) {
    return (
      <UploadSuccessComponent
        containerClassName={statesContainerClassName}
        name={file?.name || ''}
        isInProgress={true}
        onCancel={() => {
          setFile(null);
          setShowLoadingComponent(false);
        }}
        showCancelIcon={false}
      />
    );
  }

  if (hasSuccessState) {
    return (
      <UploadSuccessComponent
        containerClassName={statesContainerClassName}
        name={file?.name as string}
        isInProgress={false}
        onCancel={() => {
          setFile(null);
          setError({ message: '', fileName: '' });
        }}
      />
    );
  }

  return (
    <UploadComponent
      setFile={setFile}
      file={file}
      uploadContentContainer={CustomFileUploadComponent}
      containerClassName={styles.subContainer}
      supportedFile={supportedFile}
      setHasError={setError}
      MAX_FILE_SIZE_IN_MB={5}
      isSampleFileAvailable={isSampleFileAvailable}
      onSampleFileDownload={handleDownloadClick}
      customClassName={styles.text2}
      disabled={showLoadingComponent}
      textClassnameContainer="mt-5 mb-1 text-[var(--grayscale-3)]"
    />
  );
};

export default UploadedFileStates;
